// extracted by mini-css-extract-plugin
export default {"horizontalContainer":"HorizontalContainer_horizontalContainer__b4efA"};